<template>
  <template v-if="silent && fieldErrors && fieldErrors.$silentErrors && fieldErrors.$silentErrors.length">
    <div
      v-for="error of fieldErrors.$silentErrors"
      :key="error.$message"
    >
      <div
        v-if="error.$propertyPath === field"
        class="field-error-message"
      >
        <i class="far fa-exclamation-circle" />
        <small class="p-error">{{ error.$message }}</small>
      </div>
    </div>
  </template>
  <template v-if="!silent && fieldErrors && fieldErrors.$errors && fieldErrors.$errors.length">
    <div
      v-for="error of fieldErrors.$errors"
      :key="error.$message"
    >
      <div
        v-if="error.$propertyPath === field"
        class="field-error-message"
      >
        <i class="far fa-exclamation-circle" />
        <small class="p-error">{{ error.$message }}</small>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';

export default defineComponent({
  name: 'FieldErrors',

  props: {
    errors: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },

    field: {
      type: String,
      required: true,
      default: '',
    },

    silent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props: {errors: any; field: string; silent: boolean}) {
    const fieldErrors: any = ref(null);

    const getFieldFromObject = () => {
      const fieldNames = props.field.split('.');
      // Handle both Ref objects (with .value) and plain objects
      let result = props.errors;
      if (result && typeof result === 'object' && 'value' in result) {
        result = result.value;
      }
      if (!result || typeof result !== 'object') {
        return null;
      }

      for (let i = 0; i < fieldNames.length; i++) {
        const fn = fieldNames[i];
        if (Object.prototype.hasOwnProperty.call(result, fn)) {
          result = result[fn];
        } else {
          return null;
        }
      }

      return result;
    };

    onMounted(() => {
      fieldErrors.value = getFieldFromObject();
    });

    watch(() => props.errors, () => {
      fieldErrors.value = getFieldFromObject();
    }, { deep: true });

    return {
      fieldErrors,
    };
  },
});
</script>

<style lang="scss" scoped>
.field-error-message {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.375rem;
  animation: shake 0.3s ease-in-out;

  i {
    color: #ef4444;
    font-size: 0.875rem;
    flex-shrink: 0;
  }

  small {
    font-size: 0.8125rem;
    line-height: 1.4;
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(4px);
  }
}
</style>
